import { Table, Typography, Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TradeBookService from '../../services/TradeBookService';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';

const { Title, Text } = Typography;

const OrderExecutionList = ({ tradeOrderId }) => {
  const [orderExecutionList, setOrderExecutionList] = useState();
  const [loading, setLoading] = useState(false);
  // const { tradeOrderId } = useParams();
  const navigate = useNavigate();
  const { showNotification } = useAuth();
  console.log(tradeOrderId);

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await TradeBookService.getOrderExecutionList({ tradeOrderId });
      setLoading(false);
      if (result.success) {
        setOrderExecutionList(result.orderExecutionDataList);
      } else {
        showNotification('error', result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const tableColumns = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Fix Execution ID',
      dataIndex: 'fixExecutionId',
      key: 'fixExecutionId',
    },
    {
      title: 'Symbol Code',
      dataIndex: 'symbolCode',
      key: 'symbolCode',
    },
    {
      title: 'Executed Quantity',
      dataIndex: 'executedQuantity',
      key: 'executedQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Executed Price',
      dataIndex: 'executedPrice',
      key: 'executedPrice',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
  ];

  return (
    <Table
      columns={tableColumns}
      dataSource={orderExecutionList}
      size={'large'}
      scroll={{
        x: 'max-content',
      }}
      loading={loading}
      bordered
    />
  );
};

export default OrderExecutionList;
